import { Table } from 'antd';
import React from 'react';

type Props = {
    payments: any;
}

const ParentOrganismTopUpForStudentsTable: React.FC<Props> = ({ payments }) => {
    // Define columns for the table
    const columns = [
        {
            title: 'Nom',
            dataIndex: 'student',
            key: 'student',
            render: (student: any) => {
                return `${student?.name}`;
            }
        },
        {
            title: 'Date et heure',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text: string) => {
                const formattedDate = text.substring(8, 10) + '-' + text.substring(5, 7) + '-' + text.substring(0, 4) + ' ' + text.substring(11, 16);
                return formattedDate;
            }
        },
        {
            title: 'Montant rechargé',
            dataIndex: 'amount',
            key: 'amount',
            render: (amount: string) => {
                return `${amount} €`;
            }
        }
    ];

    return (
        <Table dataSource={payments} columns={columns} />
    );
};

export default ParentOrganismTopUpForStudentsTable;
